<div class="mt-4 mb-4" *ngIf="reception">
  <ol class="breadcrumb bg-white">
    <li class="breadcrumb-item"><button class="btn btn-sm btn-link" [routerLink]="['/inventory/reception']">Réceptions</button></li>
    <li class="breadcrumb-item"><button class="btn btn-sm btn-link" [routerLink]="['/inventory/reception']" [queryParams]="{supplier: reception.supplier.name}">{{ reception.supplier.name }}</button></li>
    <li class="breadcrumb-item active"><button class="btn btn-sm btn-link" disabled>{{ reception.id }}</button></li>
  </ol>
</div>

<div class="pb-2 bg-white rounded shadow-sm container-fluid" *ngIf="reception">
  <div class="mb-3 d-flex row text-center">
    <div class="p-2 col-xl">
      <h5>{{ reception.supplier.name }}</h5>
      <div>Références: <strong>{{ reception.details.length }}</strong></div>
      <div>Commandées: <strong>{{ ordered }}</strong></div>
      <div>À recevoir: <strong>{{ toReceive }}</strong></div>
      <div>Reçues: <strong>{{ received }}</strong></div>
      <div *ngIf="reception.supplierInvoiceNumber">
        <strong>Facture</strong>
        <button 
          class="btn btn-sm btn-link" 
          *ngIf="reception.invoiceId != undefined" 
          [routerLink]="['/purchase/invoice', reception.invoiceId]"
        >
          <span>{{ reception.supplierInvoiceNumber }}</span>
        </button>
        <span *ngIf="reception.invoiceId == undefined">
          {{ reception.supplierInvoiceNumber }}
        </span>
      </div>
    </div>
    
    <div class="p-2 col-xl">
      <div>
        <reception-status [status]="reception.status"></reception-status>
      </div>
    </div>

    <div class="p-2 col-xl-5">
      <div>Réception ouverte le <strong>{{ reception.creationTimestamp | date: 'medium' }}</strong></div>
      <div *ngIf="reception.confirmTimestamp">Confirmée le <strong>{{ reception.confirmTimestamp | date: 'medium' }}</strong></div>
    </div>
  </div>

  <div class="pb-2 input-group" *ngIf="reception.status == 'OPEN'">
    <div class="input-group-prepend">
      <span class="input-group-text">
        Référence
      </span>
    </div>
    <span class="form-control input-group-text" *ngIf="searching">
      <span class="mr-1 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      Recherche en cours...
    </span>
    <input 
      #isbnInput
      class="form-control" 
      placeholder="Isbn" 
      [(ngModel)]="isbn" 
      (keyup.enter)="searchIsbn()"
      [attr.disabled]="readOnly ? 'disabled' : null"
      [hidden]="searching"
    />
  </div>

  <ng-container *ngIf="result"> 
    <div class="alert alert-warning alert-dismissible fade show" *ngIf="result.unknownIsbn">
      <strong>Oh noez!</strong> L'ISBN {{ result.isbn }} n'existe pas. Scanner une deuxième fois pour créer la référence chez {{ reception.supplier.name }}
      <button type="button" class="close" (click)="dismissResult()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-warning alert-dismissible fade show" *ngIf="result.isbnNotActiveWithSupplier">
      <strong>Oh noez!</strong> L'ISBN {{ result.isbn }} n'existe pas chez le fournisseur. Scanner une deuxième fois pour créer la référence chez {{ reception.supplier.name }}
      <button type="button" class="close" (click)="dismissResult()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="error == true">
    <div class="alert alert-danger alert-dismissable fade show">
      <strong>Oh noez!</strong> Une erreur est survenue!
      <button type="button" class="close" (click)="error = null">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </ng-container>

  <header class="btn-group  d-flex">
    <button type="button" class="w-100 btn" [ngClass]="showReceived ? 'btn-primary' : 'btn-light'" (click)="showReceived = true">Recu</button>
    <button type="button" class="w-100 btn" [ngClass]="!showReceived ? 'btn-primary' : 'btn-light'" (click)="showReceived = false">À saisir</button>
  </header>

  <table class="table table-sm table-hover text-center align-middle">
    <thead>
      <tr>
        <th scope="col">&nbsp;</th>
        <th scope="col">Référence</th>
        <th scope="col">Reçu</th>
        <th scope="col">
          <span class="d-none d-sm-block">Commandé</span>
        </th>
        <th scope="col">Expédié</th>
        <th scope="col">
          <span *ngIf="showReceived">Étiquette</span>
        </th>
        <th scope="col">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      <tr 
        reception-detail 
        [detail]="detail"
        [invoice]="invoice"
        [readOnly]="readOnly"
        [reception]="reception"
        [showReceived]="showReceived"
        [detailsReceived]="detailsReceived"
        [detailsToReceive]="detailsToReceive"
        [referencesPrintToggle]="referencesPrintToggle"
        *ngFor="let detail of showReceived ? detailsReceived : detailsToReceive" 
      ></tr>

      <tr *ngIf="showReceived ? detailsReceived.length == 0 : detailsToReceive.length == 0">
        <td colspan="6">
          <span *ngIf="!showReceived">Tous les produits à recevoir sont saisis</span>
          <span *ngIf="showReceived">Aucun produit à recevoir n'est saisi</span>
        </td>
      </tr>
    </tbody>
  </table>

  <footer class="pb-3 d-flex">
    <ng-container *ngIf="reception.status == 'OPEN'">
      <ng-container *ngIf="processing">
        <button class="btn btn-sm btn-success ml-auto" (click)="confirm()" [attr.disabled]="readOnly ? 'disabled' : null">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Chargement...
        </button>
      </ng-container>
      <ng-container *ngIf="!processing">
        <button class="btn btn-sm btn-success ml-auto" *ngIf="referencesPrintToggle.size == 0" (click)="confirm()">Confirmer</button>
        <button class="btn btn-sm btn-success ml-auto" *ngIf="referencesPrintToggle.size != 0" data-toggle="modal" data-target="#confirm-print-label">Confirmer</button>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="reception.status == 'CONFIRMED'">
      <button class="btn btn-sm btn-danger ml-auto" (click)="reopen()">Rouvrir</button>
      <button class="btn btn-sm btn-outline-secondary ml-2" (click)="printLabels()" [attr.disabled]="referencesPrintToggle.size == 0 ? 'disabled' : null">Réimprimer les étiquettes</button>
    </ng-container>
  </footer>

  <div id="confirm-print-label" class="modal" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <p>Imprimer les étiquettes?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="mr-auto btn btn-outline-secondary" data-dismiss="modal">Retour</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="confirm()">Non</button>
          <button type="button" class="btn btn-success" data-dismiss="modal" (click)="printLabelsAndConfirm()">Oui</button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #modal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Nouvelle référence - {{newIsbn}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label>Titre</label>
      <div class="input-group">
        <input text="type" class="form-control" [(ngModel)]="title" />
      </div>
    </div>
    <div class="form-group">
      <label>Prix</label>
      <div class="input-group">
        <input text="number" class="form-control" [(ngModel)]="price" step="0.01" min="0" max="9999"  />
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.close()">Annuler</button>
    <button type="button" class="btn btn-primary" [attr.disabled]="price == 0 || title == '' ? 'disabled' : null" (click)="createReference(modal)">Créer</button>
  </div>
</ng-template>
